import { render, staticRenderFns } from "./StudentListHeader.vue?vue&type=template&id=1a5d0cd4&scoped=true&"
import script from "./StudentListHeader.vue?vue&type=script&lang=js&"
export * from "./StudentListHeader.vue?vue&type=script&lang=js&"
import style0 from "./StudentListHeader.vue?vue&type=style&index=0&id=1a5d0cd4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a5d0cd4",
  null
  
)

export default component.exports